import { render, staticRenderFns } from "./toTakeOrders.vue?vue&type=template&id=533855ab&scoped=true&"
import script from "./toTakeOrders.vue?vue&type=script&lang=js&"
export * from "./toTakeOrders.vue?vue&type=script&lang=js&"
import style0 from "./toTakeOrders.vue?vue&type=style&index=0&id=533855ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533855ab",
  null
  
)

export default component.exports